export interface ElementActionability {
  disabled: boolean;
  readOnly: boolean;
}

/**
 * Throws a consistent, Operator-facing error when a control is unmounted, disabled, or read-only.
 * The prop checks cover the brief interval before a rerender unregisters a newly unavailable tool.
 */
export const assertElementIsActionable: <T extends { isConnected: boolean }>(
  element: T | null | undefined,
  actionability: ElementActionability,
  subject: string,
  verb: string
) => asserts element is T = (element, { disabled, readOnly }, subject, verb) => {
  if (!element?.isConnected) {
    throw new Error(`${subject} is not currently rendered, so it could not be ${verb}.`);
  }
  if (disabled) {
    throw new Error(`${subject} is disabled, so it could not be ${verb}.`);
  }
  if (readOnly) {
    throw new Error(`${subject} is read-only, so it could not be ${verb}.`);
  }
};
